import {HttpClient, HttpParams} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {shareReplay} from 'rxjs/operators';
import {ApplicationPackage} from 'src/app/enums/application-package.enum';
import {Service} from 'src/app/enums/service.enum';
import {CustomHttpUrlEncodingCodec} from 'src/app/main/encoder';
import {ActivityLog, PageOfActivityLog, PageOfTrailerActivityLog} from 'src/app/model/activity-log.model';
import {environment} from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ActivityLogService {
  readonly activityLogApi = environment.endPoint + ApplicationPackage.CMS_VOD + Service.ACTIVITYLOGS;

  constructor(private http: HttpClient) {}

  private oldStatusCache: {[key: string]: Observable<boolean>} = {};

  getActivityLogs(
    page?: number,
    itemCount?: number,
    assetId?: string,
    userId?: string,
    assetType?: string,
    scope?: string,
    justUserChanges?: boolean,
  ): Observable<PageOfActivityLog> {
    let queryParams = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
    page = page - 1;
    if (page > -1) {
      queryParams = queryParams.set('page', <any>page);
    }
    if (itemCount) {
      queryParams = queryParams.set('itemCount', <any>itemCount);
    }
    if (userId) {
      queryParams = queryParams.set('userId', <any>userId);
    }
    if (assetType) {
      queryParams = queryParams.set('assetType', <any>assetType);
    }
    if (scope) {
      queryParams = queryParams.set('scope', <any>scope);
    }
    if (assetId) {
      queryParams = queryParams.set('assetId', <any>assetId);
    }
    if (justUserChanges) {
      queryParams = queryParams.set('justUserChanges', <any>justUserChanges);
    }

    return this.http.get<PageOfActivityLog>(this.activityLogApi, {params: queryParams});
  }

  getTrailersActivityLogs(page: number, itemCount: number): Observable<PageOfTrailerActivityLog> {
    let queryParams = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
    if (page > 0) {
      queryParams = queryParams.set('page', <any>page);
    }
    if (itemCount) {
      queryParams = queryParams.set('itemCount', <any>itemCount);
    }
    return this.http.get<PageOfTrailerActivityLog>(this.activityLogApi + `/trailer`, {params: queryParams});
  }

  getAllByAssetId(assetIds: string[], assetType?: string, scope?: string,): Observable<ActivityLog[]> {
    let queryParams = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
    if (assetType) {
      queryParams = queryParams.set('assetType', <any>assetType);
    }
    if (scope) {
      queryParams = queryParams.set('scope', <any>scope);
    }
    if (assetIds.length) {
      queryParams = queryParams.set('assetIds', <any>assetIds);
    }
    return this.http.get<ActivityLog[]>(this.activityLogApi + `/info`, {params: queryParams});
  }

  getOldStatus(assetId: string, processType: string): Observable<boolean> {
    const cacheKey = `${assetId}-${processType}`;

    if (this.oldStatusCache[cacheKey]) {
      return this.oldStatusCache[cacheKey];
    }
    let queryParams = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
    if (assetId) {
      queryParams = queryParams.set('assetId', assetId);
    }
    if (processType) {
      queryParams = queryParams.set('processType', processType);
    }

    this.oldStatusCache[cacheKey] = this.http.get<boolean>(`${this.activityLogApi}/getprocessstatus`, {params: queryParams}).pipe(shareReplay(1));

    return this.oldStatusCache[cacheKey];
  }

  clearOldStatusCache(assetId: string, processType: string): void {
    const cacheKey = `${assetId}-${processType}`;
    delete this.oldStatusCache[cacheKey];
  }

  // Tüm cache’i temizlemek isterseniz
  clearAllOldStatusCache(): void {
    this.oldStatusCache = {};
  }
}
